var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('p', {
    staticClass: "px-4 title primary--text"
  }, [_vm._v(_vm._s(_vm.$t('Event Bonus')))]), _c('Scroller', {
    attrs: {
      "icon": _vm.$size(64)
    }
  }, [_vm._l(_vm.characters, function (character) {
    return _c('div', {
      key: "questlibrary-eventbonus-".concat(character.m_CharaID),
      staticClass: "ml-4"
    }, [_c('router-link', {
      attrs: {
        "to": "/character/".concat(character.m_CharaID)
      }
    }, [_c('CharaIcon', {
      attrs: {
        "id": character.m_CharaID,
        "size": _vm.$size(64)
      }
    })], 1), _c('div', {
      staticClass: "caption text-center"
    }, _vm._l(character.m_ItemIDs, function (item, i) {
      return item != -1 ? _c('div', {
        key: "questlibrary-eventbonus-item-".concat(character.m_CharaID, "-").concat(item),
        staticClass: "d-flex justify-center"
      }, [_c('v-avatar', {
        staticClass: "mr-1",
        attrs: {
          "size": _vm.$size(32)
        }
      }, [_c('v-img', {
        attrs: {
          "src": _vm.$asset.itemicon.format(item) + '.jpg'
        }
      })], 1), _c('div', {
        staticClass: "d-flex justify-center flex-column"
      }, [_vm._v("+" + _vm._s(character.m_Pluses[i]))])], 1) : _vm._e();
    }), 0)], 1);
  }), _c('div', {
    staticClass: "pl-4"
  })], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }